import { actionstepSimulatorStore } from "@/lib/actionstepSimulatorStore";

const ATLAS_FOLDER = "ATLAS Letters";

export function getAtlasActionstepFolder() {
  return ATLAS_FOLDER;
}

export function getAtlasLetterFileName(documentType, dateReceived) {
  const [day = "01", month = "01", year = "1970"] = String(dateReceived || "").split(" ")[0].split("/");
  const sortableDate = `${year.padStart(4, "0")}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  const safeType = String(documentType || "ATLAS LETTER").replace(/[\\/:*?"<>|]/g, "-").replace(/\s+/g, " ").trim();
  return `${safeType} - ${sortableDate}.pdf`;
}

export function fileAtlasLetterInActionstepSimulator(message, { attachment = false } = {}) {
  const snapshot = actionstepSimulatorStore.snapshot();
  const sourceId = `${message.id}${attachment ? ":attachment" : ""}`;
  const existing = snapshot.documents.find((document) => document.atlasMessageId === sourceId);
  if (existing) return { document: existing, duplicate: true, folderName: existing.folderName };

  const matter = snapshot.matters.find((item) => String(item.externalId) === String(message.actionstepMatterId));
  if (!matter) throw new Error(`No simulated Actionstep matter is mapped to ${message.fileExt}.`);
  const documentType = attachment ? message.attachment : message.documentType;
  const folderName = getAtlasActionstepFolder();
  const sizeText = attachment ? message.attachmentSize : message.size;
  const sizeKb = Number.parseInt(String(sizeText), 10) || 1;
  const document = actionstepSimulatorStore.createDocument(matter.externalId, {
    name: getAtlasLetterFileName(documentType, message.dateReceived),
    size: sizeKb * 1024,
    type: "application/pdf",
    folderName,
    atlasMessageId: sourceId,
    atlasFileExt: message.fileExt,
    atlasDocumentType: documentType,
    source: "ATLAS Simulator",
  });
  actionstepSimulatorStore.createFileNote(matter.externalId, `ATLAS simulator document filed: ${document.name}\nATLAS File/Ext: ${message.fileExt}\nActionstep folder: VLA Funding docs / ${folderName}`, "ATLAS Simulator");
  if (!attachment && (/REFUSAL/.test(message.documentType) || message.documentType === "REQ - GENERAL - SUBMITTING OFFICE")) {
    actionstepSimulatorStore.createTask(matter.externalId, {
      title: message.documentType === "REQ - GENERAL - SUBMITTING OFFICE" ? "Respond to ATLAS information request" : "Review ATLAS refusal and reconsideration options",
      status: "Incomplete",
      dueDate: "2026-08-22",
    });
  }
  return { document, duplicate: false, folderName, matter };
}
